import React, { useContext } from 'react'
import MediaQuery from 'react-responsive'
import { Radio } from 'antd'
import { RUB, USD, EUR } from 'constants/currency'
import { RateCurrencyContext } from 'constants/rateCurrencyContext'
import { setCurrency } from 'services/currencies'
import { DEFAULT_RATE_CURRENCY, currencies } from '../../constants/currency'
import { LAPTOP_OR_DESKTOP } from 'constants/breakpoints'
import { RateRadioGroup, RateSelect } from './styles'
import { Select } from 'antd'

function RateCurrencySwitch() {
  const { currentCurrency, setCurrentCurrency } = useContext(
    RateCurrencyContext
  )

  const handleChange = newCurrency => {
    setCurrentCurrency(prev => ({
      ...prev,
      ...{ type: newCurrency }
    }))
    setCurrency(newCurrency)
  }

  return (
    <>
      <MediaQuery maxWidth={LAPTOP_OR_DESKTOP}>
        <RateRadioGroup
          onChange={event => handleChange(event.target.value)}
          defaultValue={DEFAULT_RATE_CURRENCY.type}
        >
          {currentCurrency.type !== USD && (
            <Radio.Button value={USD}>{USD}</Radio.Button>
          )}
          {currentCurrency.type !== EUR && (
            <Radio.Button value={EUR}>{EUR}</Radio.Button>
          )}
          {currentCurrency.type !== RUB && (
            <Radio.Button value={RUB}>{RUB}</Radio.Button>
          )}
        </RateRadioGroup>
      </MediaQuery>
      <MediaQuery minWidth={LAPTOP_OR_DESKTOP}>
        <RateSelect
          defaultValue={DEFAULT_RATE_CURRENCY.type}
          onChange={handleChange}
          value={currentCurrency.type}
        >
          {currencies?.map((currency, index) => (
            <Select.Option key={currency.value} value={currency.value}>
              {currency.name}
            </Select.Option>
          ))}
        </RateSelect>
      </MediaQuery>
    </>
  )
}

export default RateCurrencySwitch
